var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChromeColorized(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1423 15.1855H42.8879C44.14 17.8626 44.8388 20.8494 44.8388 24.0002C44.8388 35.5093 35.509 44.8391 23.9999 44.8391C23.5391 44.8391 23.0814 44.824 22.6282 44.7946L20.6566 32.9953",
    fill: "#FCBD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.33 27.5243C30.6115 27.1862 31.3136 28.942 31.5386 28.5702C31.5701 28.518 31.6017 28.4648 31.6331 28.4115L22.6283 44.7942C11.7583 44.0879 3.16107 35.0482 3.16107 24C3.16107 19.5481 4.55663 15.4223 6.93582 12.0366L16.2744 28.2476",
    fill: "#16A663"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.888 15.1855L25.3994 19.8439L24.3522 12.6704L42.888 15.1855Z",
    fill: "#FD9F37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.888 15.1854H24.1348C23.9946 15.1833 23.8533 15.1843 23.712 15.1886L15.7353 27.0683C15.8863 27.477 16.0668 27.8705 16.2743 28.2477L15.669 27.1967L6.93579 12.0366C10.7052 6.66851 16.9428 3.16113 24 3.16113C32.3582 3.16113 39.5675 8.08254 42.888 15.1854Z",
    fill: "#ED402D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 32.261C28.5623 32.261 32.2608 28.5625 32.2608 24.0001C32.2608 19.4378 28.5623 15.7393 24 15.7393C19.4376 15.7393 15.7391 19.4378 15.7391 24.0001C15.7391 28.5625 19.4376 32.261 24 32.261Z",
    fill: "#4192CF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6284 44.7943L25.4391 31.111L31.5387 28.5703L22.6284 44.7943Z",
    fill: "#12945A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.396 21.2568L15.7353 27.0683L15.669 27.1966L6.93579 12.0366L17.396 21.2568Z",
    fill: "#E1382A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24 32.8688C19.1096 32.8688 15.131 28.8903 15.131 23.9999C15.131 19.1095 19.1097 15.1309 24 15.1309C28.8903 15.1309 32.869 19.1095 32.869 23.9999C32.869 28.8903 28.8903 32.8688 24 32.8688ZM24 17.0177C20.1499 17.0177 17.0179 20.1499 17.0179 23.9999C17.0179 27.8499 20.15 30.982 24 30.982C27.8499 30.982 30.9822 27.8498 30.9822 23.9999C30.9821 20.1499 27.85 17.0177 24 17.0177Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeColorized);
export default __webpack_public_path__ + "static/media/chrome-colorized.67fdeb831d4c3e87bd29bf7a7439fca7.svg";
export { ForwardRef as ReactComponent };